// extracted by mini-css-extract-plugin
module.exports = {"franchiseText":"_2P7kZ","content":"_2IfBS","description":"_2gWq-"};